'use client';

import { c as _c } from "react/compiler-runtime";
import { StarIcon as StarIconOutline } from '@heroicons/react/24/outline';
import { StarIcon as StarIconSolid } from '@heroicons/react/24/solid';
export interface StarRatingProps {
  ratingOutOfFive: number;
  color?: string;
}
export const StarRating = props => {
  const $ = _c(9);
  const {
    ratingOutOfFive,
    color
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex w-fit gap-[2px]">{Array.from({
        length: 5
      }).map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = `${ratingOutOfFive * 20}%`;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      width: t1
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = Array.from({
      length: 5
    });
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== color) {
    t4 = t3.map((__0, i_0) => <StarIconSolid key={i_0} className="size-[14px] shrink-0" style={{
      color
    }} />);
    $[4] = color;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <div className="relative w-fit">{t0}<div className="absolute inset-0 flex gap-[2px] overflow-hidden" style={t2}>{t4}</div></div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
function _temp(_, i) {
  return <StarIconOutline key={i} className="size-[14px] text-bodi-gray-medium" />;
}